<footer class="header-container">
  <a href="https://mosten.com/" target="_blank">
    &copy; 2025 - Mosten v{{ this.version }}
  </a>
</footer>
